module.exports = __webpack_public_path__ + "static/media/localization.2871b13a.svg";